var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 179,
    height: 201,
    viewBox: "0 0 179 201",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.3772 201C125.038 201 156.378 194.739 156.378 187.017C156.378 179.294 125.038 173.034 86.3772 173.034C47.7166 173.034 16.376 179.294 16.376 187.017C16.376 194.739 47.7166 201 86.3772 201Z",
    fill: "#FFC181"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M86.3772 201C125.038 201 156.378 194.739 156.378 187.017C156.378 179.294 125.038 173.034 86.3772 173.034C47.7166 173.034 16.376 179.294 16.376 187.017C16.376 194.739 47.7166 201 86.3772 201Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M160.691 1.00006H110.218C108.494 1.00006 107.096 2.39617 107.096 4.11836V59.6943C107.096 61.4165 108.494 62.8126 110.218 62.8126H160.691C162.415 62.8126 163.813 61.4165 163.813 59.6943V4.11836C163.813 2.39617 162.415 1.00006 160.691 1.00006Z",
    fill: "white",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M110.218 1.00004H160.686C161.51 1.00004 162.3 1.32694 162.882 1.90882C163.465 2.49071 163.792 3.27991 163.792 4.10282V7.34005H107.096V4.11833C107.094 3.70826 107.174 3.30184 107.33 2.92258C107.486 2.54333 107.716 2.19875 108.006 1.90878C108.297 1.61881 108.642 1.3892 109.021 1.23322C109.401 1.07724 109.808 0.997983 110.218 1.00004Z",
    fill: "#222222",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M110.187 34.0032H133.008",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M110.187 36.9457H133.008",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M110.187 39.8882H133.008",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M110.187 42.8307H133.008",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M110.187 45.7731H133.008",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M110.187 48.7208H133.008",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M110.187 51.6633H133.008",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M110.187 54.6057H133.008",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M110.187 57.5482H133.008",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M137.021 34.0032H159.842",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M137.021 36.9457H159.842",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M137.021 39.8882H159.842",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M137.021 42.8307H159.842",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M137.021 45.7731H159.842",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M137.021 48.7208H159.842",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M137.021 51.6633H159.842",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M137.021 54.6057H159.842",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M137.021 57.5482H159.842",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M125.45 15.3711C125.562 15.0217 125.622 14.6574 125.626 14.2903C125.626 12.9509 124.264 12.8734 122.928 12.8734H122.592V12.5579H128.421V12.8734C126.905 12.8734 126.351 13.8404 125.879 15.2729L122.773 24.5346C122.54 25.2224 122.343 25.7344 121.613 25.7344H121.551L118.818 16.8863L116.276 24.5553C116.038 25.2431 115.841 25.7551 115.111 25.7551H115.054L111.078 12.8734H109.68V12.5579H114.795V12.8734H113.34L116.291 23.0195H116.41L118.637 16.2813L117.601 12.8992H116.203V12.5579H121.324V12.8734H119.869L122.82 23.0195H122.934L125.45 15.3711Z",
    fill: "#FF7C02"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M160.002 9.62579H136.519V30.8281H160.002V9.62579Z",
    fill: "#FF7C02",
    stroke: "#222222",
    strokeWidth: 0.53608,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M160.003 18.4894C159.215 18.5342 158.432 18.6432 157.662 18.8152C154.095 19.5909 153.163 24.7053 149.13 24.7053C145.558 24.7053 145.253 19.9011 140.132 19.2806C138.887 19.0846 137.611 19.3103 136.508 19.9218V30.8281H160.003V18.4894Z",
    fill: "#222222",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M144.321 14.4764C144.322 14.9985 144.168 15.5091 143.878 15.9436C143.588 16.3781 143.176 16.717 142.693 16.9172C142.211 17.1175 141.679 17.1701 141.167 17.0685C140.654 16.9669 140.183 16.7157 139.813 16.3465C139.444 15.9773 139.192 15.5069 139.091 14.9949C138.989 14.4828 139.042 13.9521 139.242 13.4699C139.443 12.9878 139.782 12.576 140.217 12.2866C140.652 11.9972 141.163 11.8432 141.686 11.8442C142.384 11.8442 143.055 12.1216 143.549 12.6152C144.043 13.1088 144.321 13.7783 144.321 14.4764Z",
    fill: "white",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M161.074 2.85651H108.8V4.86814H161.074V2.85651Z",
    fill: "white",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M157.812 75.1461H135.183C134.293 75.1461 133.44 75.4992 132.811 76.1276C132.181 76.756 131.828 77.6084 131.828 78.4971V90.5876C131.828 91.4764 132.181 92.3287 132.811 92.9571C133.44 93.5856 134.293 93.9386 135.183 93.9386H135.877C135.172 95.49 133.806 97.8688 131.647 99.2806C131.647 99.2806 136.239 98.9599 141.023 93.9386H157.802C158.692 93.9386 159.545 93.5856 160.174 92.9571C160.803 92.3287 161.157 91.4764 161.157 90.5876V78.4971C161.157 77.6102 160.805 76.7594 160.178 76.1312C159.551 75.5031 158.7 75.1489 157.812 75.1461Z",
    fill: "#222222",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M142.607 84.1131C142.608 83.7711 142.507 83.4364 142.318 83.1516C142.128 82.8668 141.858 82.6446 141.542 82.5132C141.226 82.3818 140.878 82.3472 140.542 82.4137C140.206 82.4802 139.897 82.6448 139.655 82.8866C139.413 83.1285 139.248 83.4367 139.182 83.7723C139.115 84.1078 139.15 84.4555 139.281 84.7713C139.413 85.0871 139.635 85.3568 139.92 85.5462C140.206 85.7356 140.541 85.8362 140.883 85.8352C141.34 85.8338 141.778 85.6519 142.101 85.3293C142.424 85.0066 142.606 84.5694 142.607 84.1131Z",
    fill: "#FF7C02",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M148.473 84.1132C148.473 83.7726 148.372 83.4396 148.182 83.1564C147.993 82.8732 147.724 82.6525 147.409 82.5222C147.094 82.3919 146.747 82.3578 146.413 82.4242C146.078 82.4906 145.771 82.6547 145.53 82.8955C145.289 83.1363 145.125 83.4432 145.058 83.7772C144.992 84.1112 145.026 84.4575 145.156 84.7722C145.287 85.0868 145.508 85.3558 145.791 85.545C146.075 85.7342 146.408 85.8352 146.749 85.8352C147.206 85.8338 147.643 85.652 147.966 85.3293C148.289 85.0067 148.472 84.5694 148.473 84.1132Z",
    fill: "#FF7C02",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M154.344 84.1131C154.345 83.7713 154.244 83.4368 154.055 83.1521C153.866 82.8674 153.596 82.6452 153.28 82.5137C152.964 82.3822 152.616 82.3472 152.281 82.4133C151.945 82.4794 151.636 82.6434 151.394 82.8848C151.151 83.1261 150.986 83.4339 150.919 83.7691C150.852 84.1043 150.886 84.4518 151.017 84.7677C151.147 85.0836 151.369 85.3537 151.653 85.5437C151.938 85.7337 152.272 85.8352 152.615 85.8352C153.072 85.8338 153.51 85.6521 153.834 85.3296C154.158 85.0071 154.341 84.5699 154.344 84.1131Z",
    fill: "#FF7C02",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3678 8.33295H70.6438C71.5308 8.33295 72.3815 8.68491 73.0087 9.3114C73.6359 9.9379 73.9883 10.7876 73.9883 11.6736V37.4836H30.0388V11.6736C30.0388 10.7903 30.389 9.94292 31.0129 9.31687C31.6368 8.69082 32.4834 8.33705 33.3678 8.33295Z",
    fill: "#FF7C02",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9675 33.3207H30.0388V37.4681H73.9675V33.3207Z",
    fill: "#222222",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9588 34.7376H32.0527V36.0511H71.9588V34.7376Z",
    fill: "white",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0057 27.6219C55.3568 27.6219 58.0734 24.9084 58.0734 21.5611C58.0734 18.2139 55.3568 15.5004 52.0057 15.5004C48.6546 15.5004 45.938 18.2139 45.938 21.5611C45.938 24.9084 48.6546 27.6219 52.0057 27.6219Z",
    fill: "#222222",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2668 17.7913L55.816 21.5663L49.2668 25.3414V17.7913Z",
    fill: "white",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9671 48.0847H13.2749C12.4686 48.0847 11.8149 48.7376 11.8149 49.543V65.4137C11.8149 66.2191 12.4686 66.872 13.2749 66.872H54.9671C55.7734 66.872 56.4271 66.2191 56.4271 65.4137V49.543C56.4271 48.7376 55.7734 48.0847 54.9671 48.0847Z",
    fill: "#222222",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1268 50.6445L17.3443 51.0065C16.3606 51.5547 15.4442 52.5165 15.4442 53.6439C15.4317 53.8375 15.4579 54.0318 15.5214 54.2152C15.5849 54.3986 15.6845 54.5674 15.8142 54.7119C15.9439 54.8564 16.1011 54.9736 16.2768 55.0566C16.4524 55.1396 16.6428 55.1867 16.8369 55.1953C16.9819 55.1953 17.0802 55.1229 17.0802 54.9781C17.0802 54.8333 17.0078 54.7867 16.8628 54.7609C16.6673 54.708 16.497 54.5874 16.3823 54.4207C16.2675 54.254 16.2158 54.052 16.2364 53.8507C16.2401 53.6902 16.2766 53.532 16.3434 53.386C16.4103 53.2399 16.5062 53.109 16.6254 53.0011C16.7445 52.8932 16.8843 52.8107 17.0364 52.7585C17.1885 52.7063 17.3496 52.6856 17.51 52.6975C17.6844 52.6981 17.8569 52.7337 18.0174 52.8021C18.1778 52.8704 18.3229 52.9702 18.4441 53.0956C18.5652 53.2209 18.66 53.3693 18.7227 53.5319C18.7855 53.6944 18.815 53.8679 18.8094 54.0421C18.8069 54.2609 18.7602 54.477 18.6722 54.6775C18.5842 54.8779 18.4567 55.0586 18.2972 55.2087C18.1378 55.3588 17.9496 55.4753 17.7441 55.5512C17.5386 55.6271 17.3198 55.6608 17.101 55.6504C16.8288 55.6679 16.5561 55.6282 16.3003 55.5338C16.0445 55.4394 15.8115 55.2923 15.6163 55.1022C15.421 54.9121 15.2679 54.6831 15.167 54.4301C15.066 54.1771 15.0193 53.9057 15.0301 53.6335C15.0145 52.3252 16.0241 51.2703 17.1268 50.6445ZM21.5741 50.6445L21.7915 51.0065C20.8027 51.5547 19.8915 52.5165 19.8915 53.6439C19.8782 53.8377 19.9039 54.0322 19.9672 54.2159C20.0304 54.3996 20.1299 54.5688 20.2597 54.7134C20.3896 54.8581 20.5471 54.9752 20.7231 55.058C20.899 55.1408 21.0898 55.1874 21.2842 55.1953C21.4291 55.1953 21.5275 55.1229 21.5275 54.9781C21.5275 54.8333 21.455 54.7867 21.31 54.7609C21.1145 54.708 20.9442 54.5874 20.8295 54.4207C20.7148 54.254 20.663 54.052 20.6836 53.8507C20.6866 53.6899 20.7226 53.5315 20.7892 53.385C20.8558 53.2386 20.9517 53.1074 21.071 52.9993C21.1903 52.8913 21.3305 52.8088 21.4829 52.7569C21.6353 52.705 21.7967 52.6848 21.9572 52.6975C22.1316 52.6981 22.3042 52.7337 22.4646 52.8021C22.6251 52.8704 22.7702 52.9702 22.8913 53.0956C23.0125 53.2209 23.1072 53.3693 23.17 53.5319C23.2327 53.6944 23.2622 53.8679 23.2567 54.0421C23.2534 54.2607 23.2063 54.4765 23.118 54.6766C23.0298 54.8767 22.9022 55.0571 22.7429 55.2071C22.5836 55.357 22.3958 55.4735 22.1905 55.5497C21.9853 55.6258 21.7669 55.6601 21.5482 55.6504C21.2763 55.6671 21.0038 55.6269 20.7484 55.5321C20.493 55.4374 20.2603 55.2904 20.0653 55.1004C19.8702 54.9104 19.7171 54.6817 19.6158 54.4291C19.5146 54.1765 19.4674 53.9055 19.4773 53.6335C19.4566 52.3252 20.4662 51.2703 21.5741 50.6445Z",
    fill: "#FF7C02"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8296 54.4713H51.2187",
    stroke: "white",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8296 56.6484H51.2187",
    stroke: "white",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8296 58.8255H51.2187",
    stroke: "white",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8296 61.0078H51.2187",
    stroke: "white",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7266 96.0017C51.967 95.1473 55.5217 90.2115 54.6664 84.9771C53.8111 79.7427 48.8695 76.192 43.6292 77.0463C38.3888 77.9007 34.834 82.8366 35.6893 88.071C36.5447 93.3053 41.4862 96.856 46.7266 96.0017Z",
    fill: "#222222",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M51.276 91.8822C54.2325 88.5194 53.9002 83.3994 50.5336 80.4462C47.167 77.493 42.0411 77.825 39.0845 81.1877C36.128 84.5505 36.4603 89.6705 39.8269 92.6237C43.1935 95.5769 48.3194 95.2449 51.276 91.8822Z",
    fill: "white",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1821 80.6639V86.523H49.1479",
    stroke: "#222222",
    strokeWidth: 0.53608,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M105.331 86.5436C105.331 86.5436 110.845 98.298 110.845 98.9185C110.845 99.5391 105.952 102.197 105.02 102.756C104.298 103.167 103.553 103.538 102.789 103.867L103.348 109.313C103.348 109.313 111.772 107.394 115.302 105.476C118.833 103.557 118.709 101.39 117.891 98.1739C117.073 94.9573 111.632 82.5255 111.632 82.5255L105.331 86.5436Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_146_2697",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 102,
    y: 82,
    width: 17,
    height: 28
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M105.331 86.5436C105.331 86.5436 110.845 98.298 110.845 98.9185C110.845 99.5391 105.952 102.197 105.02 102.756C104.298 103.167 103.553 103.538 102.789 103.867L103.348 109.313C103.348 109.313 111.772 107.394 115.302 105.476C118.833 103.557 118.709 101.39 117.891 98.1739C117.073 94.9573 111.632 82.5255 111.632 82.5255L105.331 86.5436Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_146_2697)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M115.287 105.476C118.818 103.557 118.693 101.39 117.875 98.1739C117.057 94.9573 111.616 82.5255 111.616 82.5255L110.736 83.084L110.456 83.6011C110.456 83.6011 115.535 96.0536 115.841 100.201C116.048 102.988 110.431 106.463 106.719 108.449C109.473 107.72 113.221 106.598 115.287 105.476Z",
    fill: "#FF7C02"
  })))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M105.331 86.5436C105.331 86.5436 110.845 98.298 110.845 98.9185C110.845 99.5391 105.952 102.197 105.02 102.756C104.298 103.167 103.553 103.538 102.789 103.867L103.348 109.313C103.348 109.313 111.772 107.394 115.302 105.476C118.833 103.557 118.709 101.39 117.891 98.1739C117.073 94.9573 111.632 82.5255 111.632 82.5255L105.331 86.5436Z",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5493 83.9476C65.5493 83.9476 61.5266 98.6703 61.4075 101.271C61.2885 103.873 69.396 109.003 69.6911 109.313C69.9862 109.623 69.2303 100.367 69.2303 100.367L71.9794 86.9211L65.5493 83.9476Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_146_2697",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 61,
    y: 83,
    width: 11,
    height: 27
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5493 83.9476C65.5493 83.9476 61.5266 98.6703 61.4075 101.271C61.2885 103.873 69.396 109.003 69.6911 109.313C69.9862 109.623 69.2303 100.367 69.2303 100.367L71.9794 86.9211L65.5493 83.9476Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_146_2697)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3924 85.1525L67.3044 84.7544L65.5493 83.9476C65.5493 83.9476 61.5266 98.6703 61.4075 101.271C61.2885 103.873 69.396 109.003 69.6911 109.313C69.8102 109.437 69.7636 108.051 69.6652 106.339C67.2526 104.297 63.7891 101.421 63.3852 100.211",
    fill: "#FF7C02"
  })))), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5493 83.9476C65.5493 83.9476 61.5266 98.6703 61.4075 101.271C61.2885 103.873 69.396 109.003 69.6911 109.313C69.9862 109.623 69.2303 100.367 69.2303 100.367L71.9794 86.9211L65.5493 83.9476Z",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4412 69.1577C84.4412 69.1577 82.888 70.2747 79.8593 70.3988C76.8307 70.5229 76.6857 68.3303 72.9219 68.3303C68.3607 68.3303 62.6399 82.7427 62.6399 82.7427C62.6399 82.7427 65.4874 85.53 68.2779 86.7039C69.8216 87.3794 71.4446 87.8572 73.1082 88.126L73.5431 97.5947H104.265L104.632 88.126L114.236 81.905C114.236 81.905 109.525 73.4913 107.236 70.3368C104.948 67.1823 101.101 68.3562 99.9262 69.1577C98.751 69.9593 95.2667 70.1506 93.9828 69.9644C92.3078 69.5942 90.6525 69.1402 89.023 68.6044C89.023 68.6044 87.0453 66.9599 84.4412 69.1577Z",
    fill: "#FF7C02",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4185 72.4984L73.2944 88.2139",
    stroke: "#222222",
    strokeWidth: 0.13402,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M74.532 73.9257C74.532 73.9257 74.9669 81.5947 76.6029 85.8662",
    stroke: "#222222",
    strokeWidth: 0.13402,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8875 86.4816C77.2408 87.524 77.6753 88.5372 78.1869 89.5119",
    stroke: "#222222",
    strokeWidth: 0.13402,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5208 73.0569C76.1085 75.8455 76.9383 78.5776 78.0006 81.2224",
    stroke: "#222222",
    strokeWidth: 0.13402,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M102.225 74.4169C102.225 74.4169 100.739 80.4829 99.4343 83.2081",
    stroke: "#222222",
    strokeWidth: 0.13402,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M104.632 88.1519L104.57 75.9011",
    stroke: "#222222",
    strokeWidth: 0.13402,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M103.954 76.1493C103.954 76.1493 102.836 83.9062 100.113 87.9657",
    stroke: "#222222",
    strokeWidth: 0.13402,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M102.592 86.4195C102.592 86.4195 101.35 88.7724 100.485 90.0084",
    stroke: "#222222",
    strokeWidth: 0.13402,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7068 70.0886C82.7068 70.0886 83.5766 75.4098 84.8139 78.1299C86.0513 80.85 88.2205 81.4085 90.0791 80.607C91.9378 79.8054 93.2994 75.839 93.1855 70.7815",
    stroke: "#222222",
    strokeWidth: 0.13402,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3113 58.9496C78.3113 58.9496 77.1309 56.9121 76.2042 57.9619C75.2775 59.0116 76.9497 61.4266 77.8764 62.2282C78.8032 63.0297 79.4865 62.5384 79.4296 61.6748C79.3726 60.8112 78.3113 58.9496 78.3113 58.9496Z",
    fill: "#FF7C02",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M78.3113 58.9496C78.3113 58.9496 77.1309 56.9121 76.2042 57.9619C75.2775 59.0116 76.9497 61.4266 77.8764 62.2282C78.8032 63.0297 79.4865 62.5384 79.4296 61.6748C79.3726 60.8112 78.3113 58.9496 78.3113 58.9496Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3113 58.9496C78.3113 58.9496 77.1309 56.9121 76.2042 57.9619C75.2775 59.0116 76.9497 61.4266 77.8764 62.2282C78.8032 63.0297 79.4865 62.5384 79.4296 61.6748C79.3726 60.8112 78.3113 58.9496 78.3113 58.9496Z",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0477 58.9496C97.0477 58.9496 98.2229 56.9121 99.1548 57.9619C100.087 59.0116 98.4093 61.4266 97.4826 62.2282C96.5559 63.0297 95.8673 62.5384 95.9294 61.6748C95.9916 60.8112 97.0477 58.9496 97.0477 58.9496Z",
    fill: "#FF7C02",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M97.0477 58.9496C97.0477 58.9496 98.2229 56.9121 99.1548 57.9619C100.087 59.0116 98.4093 61.4266 97.4826 62.2282C96.5559 63.0297 95.8673 62.5384 95.9294 61.6748C95.9916 60.8112 97.0477 58.9496 97.0477 58.9496Z",
    fill: "white"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0477 58.9496C97.0477 58.9496 98.2229 56.9121 99.1548 57.9619C100.087 59.0116 98.4093 61.4266 97.4826 62.2282C96.5559 63.0297 95.8673 62.5384 95.9294 61.6748C95.9916 60.8112 97.0477 58.9496 97.0477 58.9496Z",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8821 68.7285C84.4669 71.3691 85.212 73.9716 86.1135 76.5217C87.2317 79.3038 89.3337 79.3038 90.2035 77.5094C91.0732 75.7149 91.6272 69.0285 91.6272 69.0285C91.6272 69.0285 85.8028 69.8403 83.8821 68.7285Z",
    fill: "white",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4355 59.6322C78.4355 59.6322 80.0456 65.3206 83.095 68.6664C86.1444 72.0123 87.2367 72.8035 88.8572 72.5604C90.4777 72.3174 92.2017 70.2126 94.6143 65.8377C97.0269 61.4628 97.2029 58.1066 97.4048 57.7963C97.6067 57.4861 96.8871 51.3012 93.4391 48.638C89.991 45.9748 86.1288 44.806 82.7843 47.7123C79.4398 50.6186 77.3172 55.3607 78.4355 59.6322Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_146_2697",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 78,
    y: 46,
    width: 20,
    height: 27
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4355 59.6322C78.4355 59.6322 80.0456 65.3206 83.095 68.6664C86.1444 72.0123 87.2367 72.8035 88.8572 72.5604C90.4777 72.3174 92.2017 70.2126 94.6143 65.8377C97.0269 61.4628 97.2029 58.1066 97.4048 57.7963C97.6067 57.4861 96.8871 51.3012 93.4391 48.638C89.991 45.9748 86.1288 44.806 82.7843 47.7123C79.4398 50.6186 77.3172 55.3607 78.4355 59.6322Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_146_2697)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M93.4234 48.6173C89.9547 45.9592 86.1132 44.7853 82.7687 47.6916C79.4242 50.5979 77.3171 55.3606 78.4354 59.6321C78.4354 59.6321 78.7408 60.7285 79.3466 62.2178C79.3448 62.0271 79.371 61.8372 79.4242 61.6541C80.1646 59.3115 82.3494 54.7763 89.701 56.8552C95.5409 58.4996 94.8265 63.6296 94.2829 66.3652L94.5987 65.7963C97.0164 61.4059 97.1873 58.0652 97.3892 57.755C97.5911 57.4447 96.8922 51.2805 93.4234 48.6173Z",
    fill: "#FF7C02"
  })))), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4355 59.6322C78.4355 59.6322 80.0456 65.3206 83.095 68.6664C86.1444 72.0123 87.2367 72.8035 88.8572 72.5604C90.4777 72.3174 92.2017 70.2126 94.6143 65.8377C97.0269 61.4628 97.2029 58.1066 97.4048 57.7963C97.6067 57.4861 96.8871 51.3012 93.4391 48.638C89.991 45.9748 86.1288 44.806 82.7843 47.7123C79.4398 50.6186 77.3172 55.3607 78.4355 59.6322Z",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8418 62.6005C88.6498 63.8084 88.546 65.0286 88.5312 66.2515C88.5933 67.4874 88.9661 67.8597 88.4069 67.9838C87.8478 68.108 87.2317 67.2392 87.2317 67.2392",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6445 63.5934C83.0034 63.8523 83.4323 63.9968 83.8749 64.0079C84.3174 64.0189 84.753 63.8961 85.1244 63.6554",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5139 63.5934C90.872 63.8519 91.3 63.9961 91.7416 64.0072C92.1833 64.0183 92.618 63.8956 92.9886 63.6554",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6001 61.5094C86.6001 61.5094 85.4197 58.5979 81.5212 59.958",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8462 61.1525C89.8462 61.1525 90.835 58.3032 94.3659 59.9735",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3506 63.8054C87.3506 65.3982 85.5231 66.6858 83.2658 66.6858C81.0085 66.6858 79.1758 65.3982 79.1758 63.8054C79.1758 62.2126 80.8843 61.5507 83.1415 61.5507C85.3988 61.5507 87.3506 62.2178 87.3506 63.8054Z",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7681 63.8054C96.7681 65.3982 94.9354 66.6858 92.6781 66.6858C90.4208 66.6858 88.5933 65.3982 88.5933 63.8054C88.5933 62.2126 90.2966 61.5507 92.5538 61.5507C94.8111 61.5507 96.7681 62.2178 96.7681 63.8054Z",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5662 113.414L44.3125 176.105C44.3125 176.303 44.391 176.492 44.5309 176.632C44.6707 176.772 44.8603 176.85 45.058 176.85C45.2508 176.85 45.4361 176.775 45.5743 176.641C45.7126 176.507 45.793 176.324 45.7984 176.131L47.5897 113.502L44.5662 113.414Z",
    fill: "white",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3415 128.069L40.0982 192.881C40.0975 192.979 40.1163 193.076 40.1535 193.167C40.1907 193.257 40.2456 193.34 40.315 193.409C40.3844 193.478 40.4668 193.533 40.5576 193.57C40.6483 193.608 40.7456 193.626 40.8437 193.626C41.0361 193.626 41.2212 193.552 41.3602 193.419C41.4991 193.286 41.5812 193.104 41.5892 192.912L43.3753 128.152L40.3415 128.069Z",
    fill: "white",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M131.336 113.414L131.59 176.105C131.591 176.203 131.572 176.3 131.535 176.39C131.498 176.48 131.444 176.562 131.375 176.632C131.306 176.701 131.224 176.756 131.134 176.793C131.044 176.831 130.947 176.85 130.85 176.85C130.656 176.85 130.471 176.775 130.332 176.641C130.192 176.507 130.111 176.324 130.104 176.131L128.318 113.502L131.336 113.414Z",
    fill: "white",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M135.566 128.069L135.82 192.881C135.821 192.979 135.802 193.076 135.765 193.167C135.727 193.257 135.672 193.34 135.603 193.409C135.534 193.478 135.451 193.533 135.36 193.57C135.27 193.608 135.172 193.626 135.074 193.626C134.882 193.626 134.698 193.551 134.56 193.418C134.422 193.285 134.341 193.104 134.334 192.912L132.543 128.152L135.566 128.069Z",
    fill: "white",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7585 130.763L69.6083 188.289C69.592 188.432 69.6319 188.577 69.7197 188.691C69.8076 188.806 69.9365 188.882 70.0795 188.904C70.219 188.885 70.346 188.813 70.4345 188.704C70.5229 188.594 70.5663 188.455 70.5558 188.315L71.6792 130.831L69.7585 130.763Z",
    fill: "white",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M106.211 128.912L106.351 179.115C106.363 179.237 106.328 179.358 106.253 179.454C106.177 179.55 106.068 179.614 105.947 179.632C105.827 179.614 105.718 179.55 105.644 179.454C105.569 179.357 105.535 179.236 105.549 179.115L104.591 128.953L106.211 128.912Z",
    fill: "white",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1942 128.912L69.334 179.115C69.3459 179.237 69.3107 179.358 69.2355 179.454C69.1604 179.55 69.051 179.614 68.9302 179.632C68.8097 179.614 68.7008 179.55 68.6265 179.454C68.5522 179.357 68.5181 179.236 68.5315 179.115L67.5737 128.953L69.1942 128.912Z",
    fill: "white",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M105.171 130.763L105.331 188.289C105.348 188.432 105.308 188.577 105.22 188.691C105.132 188.806 105.003 188.882 104.86 188.904C104.721 188.884 104.595 188.812 104.506 188.702C104.418 188.593 104.374 188.455 104.384 188.315L103.26 130.831L105.171 130.763Z",
    fill: "white",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M87.211 134.792C99.9349 134.792 110.25 132.437 110.25 129.533C110.25 126.628 99.9349 124.273 87.211 124.273C74.4871 124.273 64.1724 126.628 64.1724 129.533C64.1724 132.437 74.4871 134.792 87.211 134.792Z",
    fill: "white",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9919 174.176C75.9919 174.176 74.7856 175.904 75.6502 176.762C76.5148 177.621 77.3742 177.279 77.2862 178.143C77.1982 179.006 75.821 181.933 74.6147 185.036C73.4084 188.139 75.909 191.242 78.2388 190.383C80.5685 189.525 80.3097 180.899 80.6514 179.348C80.9931 177.796 81.2571 177.538 81.1691 176.074C81.0811 174.611 80.9982 173.059 79.8748 172.884C78.7513 172.708 76.5096 173.577 75.9919 174.176Z",
    fill: "white",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6936 188.004C78.1404 187.415 75.7589 187.534 74.418 187.668C74.8684 189.618 76.5924 190.988 78.2388 190.383C78.9273 190.13 79.3777 189.209 79.6936 188.004Z",
    fill: "#FF7C02",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3206 170.386C73.3206 170.386 75.8212 174.611 76.5097 175.728C77.1983 176.845 79.5332 176.504 79.7921 174.952C80.0509 173.401 78.8395 169.093 78.8395 169.093L73.6623 170.386H73.3206Z",
    fill: "white",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3666 163.663C67.3666 163.663 66.6729 164.785 67.0197 165.561C67.3666 166.337 68.314 168.576 68.9198 169.698C69.5255 170.82 72.285 171.508 75.4741 170.991C78.6633 170.474 80.4805 169.005 80.5685 167.712C80.6565 166.419 80.0508 164.697 79.6159 162.629C79.181 160.56 78.0627 160.648 76.5096 160.648C74.9564 160.648 68.6609 162.458 67.3666 163.663Z",
    fill: "#FF7C02",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6856 138.324C76.7322 136.204 77.9592 135.159 78.0523 133.706C78.1984 131.785 78.0394 129.853 77.5812 127.981L75.2204 124.76C68.4279 124.847 63.5613 124.961 63.4836 124.987C63.2248 125.07 63.0488 126.538 62.8779 127.743C62.8779 127.743 59.9942 128.111 60.5119 136.126C60.5844 137.243 63.494 150.166 63.7063 151.64C65.0006 160.643 67.8843 165.153 67.8843 165.153C67.8843 165.153 68.1431 166.275 71.5083 166.016C74.8735 165.758 78.2387 163.518 78.2387 163.518C78.2387 163.518 76.5095 145.993 76.6856 138.324Z",
    fill: "#222222",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4121 126.43C62.4121 126.43 58.845 126.947 56.6602 129.44C54.4754 131.932 56.3288 133.577 60.5742 133.132C64.8195 132.687 69.7171 128.348 69.9242 128.116C70.1313 127.883 65.4977 124.935 62.4121 126.43Z",
    fill: "white",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7437 127.981C71.0163 128.098 73.2713 128.445 75.474 129.015C78.4095 129.879 83.5868 131.601 84.793 131.601C85.9993 131.601 85.6576 127.118 85.6576 126.259C85.6576 125.401 70.126 124.878 68.2259 124.878C66.3259 124.878 68.7437 127.981 68.7437 127.981Z",
    fill: "white",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6577 126.259C85.6577 126.259 84.2754 126.947 83.7577 129.533C83.24 132.118 82.5514 133.499 83.5869 134.187C84.6223 134.875 89.111 135.392 89.7995 134.704C90.4881 134.016 92.3881 130.567 92.735 128.328C93.0819 126.089 85.6577 126.259 85.6577 126.259Z",
    fill: "#FF7C02",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5236 127.118C90.7211 128.038 90.0804 129.087 89.6288 130.22C89.2628 131.407 88.974 132.616 88.7642 133.84C90.4159 134.293 92.0307 134.87 93.5945 135.568C96.3591 136.772 101.019 137.636 105.502 138.67C109.986 139.705 111.197 140.739 112.75 140.739C114.303 140.739 116.203 139.529 118.621 136.602C121.039 133.675 118.963 127.464 116.55 125.566C114.138 123.668 101.189 122.122 99.4655 122.639C97.7415 123.156 91.5236 127.118 91.5236 127.118Z",
    fill: "#222222",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1452 133.178C58.8043 131.631 58.1136 130.183 57.1261 128.943C56.9656 129.093 56.8103 129.248 56.6602 129.419C54.7394 131.601 55.9405 133.153 59.1452 133.178Z",
    fill: "#FF7C02",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4215 134.544C76.4215 134.544 74.6405 153.579 71.0061 156.542",
    stroke: "white",
    strokeWidth: 0.13402,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1635 152.612C75.1635 152.612 73.7501 158.818 70.0432 161.284",
    stroke: "white",
    strokeWidth: 0.13402,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0831 131.084C98.0831 131.084 92.559 131.43 96.1831 133.84C99.8071 136.25 106.367 137.807 106.367 137.807",
    stroke: "white",
    strokeWidth: 0.13402,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M138.186 124.563L136.322 122.888L132.015 113.579C131.81 113.156 131.489 112.799 131.09 112.551C130.69 112.303 130.228 112.173 129.757 112.178H46.0934C45.622 112.172 45.1587 112.301 44.758 112.55C44.3573 112.798 44.0357 113.155 43.831 113.579L38.4622 125.173L37.5769 124.847V127.5L37.6183 127.469C37.6711 127.823 37.8509 128.146 38.1243 128.377C38.3977 128.608 38.746 128.732 39.1042 128.726H136.741C137.119 128.735 137.484 128.596 137.762 128.341C138.039 128.085 138.206 127.732 138.227 127.356L138.186 124.563Z",
    fill: "#222222",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M136.741 126.301H39.1041C38.8623 126.31 38.622 126.258 38.4058 126.15C38.1896 126.041 38.0045 125.88 37.8679 125.68C37.7313 125.481 37.6476 125.25 37.6248 125.009C37.6019 124.768 37.6407 124.526 37.7373 124.304L43.8309 111.154C44.0346 110.729 44.3559 110.371 44.7569 110.123C45.1578 109.874 45.6216 109.746 46.0933 109.752H129.757C130.228 109.747 130.691 109.876 131.091 110.124C131.491 110.372 131.811 110.73 132.014 111.154L138.108 124.304C138.205 124.526 138.243 124.768 138.221 125.009C138.198 125.25 138.114 125.481 137.977 125.68C137.841 125.88 137.656 126.041 137.44 126.15C137.223 126.258 136.983 126.31 136.741 126.301Z",
    fill: "white",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0484 117.468C44.0484 117.468 41.8377 118.983 43.22 119.536C44.6024 120.09 60.4912 119.676 62.4275 119.123C64.3638 118.569 66.5693 113.465 66.5693 112.638C66.5693 111.811 63.784 111.216 62.7589 111.169C61.7338 111.123 48.1902 111.945 48.1902 111.945L44.0484 117.468Z",
    fill: "#FF7C02"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M123.084 120.09C126.212 120.09 128.748 119.039 128.748 117.742C128.748 116.445 126.212 115.394 123.084 115.394C119.956 115.394 117.42 116.445 117.42 117.742C117.42 119.039 119.956 120.09 123.084 120.09Z",
    fill: "#FF7C02"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0246 122.991C98.2416 122.991 107.335 121.292 107.335 119.195C107.335 117.099 98.2416 115.399 87.0246 115.399C75.8076 115.399 66.7144 117.099 66.7144 119.195C66.7144 121.292 75.8076 122.991 87.0246 122.991Z",
    fill: "#FF7C02"
  }))), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M118.942 108.506C118.942 108.506 118.569 107.022 117.332 107.518C116.095 108.015 116.219 111.293 116.462 113.15C116.706 115.006 118.383 114.138 118.383 114.138V113.026C118.383 113.026 117.767 113.517 117.456 112.84C117.146 112.162 117.208 108.754 117.518 108.816C117.829 108.878 118.445 109.928 118.445 109.928C118.445 109.928 118.632 109.809 118.942 108.506Z",
    fill: "#FF7C02",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M118.052 108.754V116.884C118.052 117.84 120.252 118.616 122.97 118.616C125.688 118.616 127.883 117.84 127.883 116.884V108.754H118.052Z",
    fill: "#FF7C02",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M127.883 108.754C127.883 109.582 125.683 110.249 122.97 110.249C120.257 110.249 118.052 109.582 118.052 108.754C118.052 107.927 120.252 107.26 122.97 107.26C125.688 107.26 127.883 107.932 127.883 108.754Z",
    fill: "white",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M127.241 108.754C127.241 109.473 125.326 110.052 122.97 110.052C120.614 110.052 118.694 109.473 118.694 108.754C118.694 108.036 120.609 107.456 122.97 107.456C125.331 107.456 127.241 108.036 127.241 108.754Z",
    fill: "white",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M119.672 109.582C121.824 110.209 124.111 110.209 126.263 109.582C124.111 108.954 121.824 108.954 119.672 109.582Z",
    fill: "#222222",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4375 112.467L43.4996 115.25L62.2671 115.436V112.219L43.4375 112.467Z",
    fill: "white",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2671 115.436L64.9955 109.561V107.829L62.1428 112.778L62.2671 115.436Z",
    fill: "white",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4375 115.001L43.4996 117.789L62.2671 117.975V114.758L43.4375 115.001Z",
    fill: "white",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2671 117.975L64.9955 112.095V110.363L62.1428 115.312L62.2671 117.975Z",
    fill: "white",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6857 105.414C50.6857 105.414 51.1206 104.55 50.4993 104.178C49.8781 103.805 49.1999 104.695 48.8271 104.979C48.4543 105.264 40.6523 110.425 40.4038 111.231C40.1552 112.038 40.4038 113.817 42.076 114.014C43.7482 114.21 45.2341 113.088 45.9796 112.902C46.7251 112.716 47.0151 112.653 47.0151 112.653L52.156 105.724L50.6857 105.414Z",
    fill: "white",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M42.076 114.019C43.7482 114.205 45.2341 113.093 45.9796 112.907C46.7251 112.721 47.015 112.659 47.015 112.659L47.2014 112.405L42.3711 111.423C42.1085 111.176 41.7708 111.023 41.4116 110.989C41.0525 110.956 40.6923 111.043 40.3882 111.237C40.1552 112.033 40.4037 113.827 42.076 114.019Z",
    fill: "white",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3865 111.433H56.8827C61.4076 111.433 62.7692 111.185 62.7692 111.185L65.5545 105.429C65.5545 105.429 56.7533 105.988 54.0352 105.802C52.9121 105.769 51.7935 105.645 50.6907 105.429L42.3865 111.433Z",
    fill: "white",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3865 111.433L42.635 112.545C42.635 112.545 54.4028 112.607 57.4988 112.607C60.5948 112.607 62.9504 112.731 62.9504 112.731L62.764 111.18L42.3865 111.433Z",
    fill: "white",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9505 112.716L65.5495 106.774V105.414L62.7642 111.169L62.9505 112.716Z",
    fill: "white",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M104.762 119.666H69.2719C69.1933 119.666 69.1153 119.652 69.0425 119.622C68.9697 119.592 68.9034 119.549 68.8476 119.493C68.7918 119.438 68.7474 119.372 68.7172 119.3C68.687 119.227 68.6714 119.15 68.6714 119.071C68.6714 118.993 68.687 118.915 68.7172 118.842C68.7474 118.77 68.7918 118.704 68.8476 118.649C68.9034 118.593 68.9697 118.55 69.0425 118.52C69.1153 118.491 69.1933 118.476 69.2719 118.476H104.762C104.84 118.476 104.918 118.491 104.99 118.52C105.063 118.55 105.129 118.594 105.184 118.649C105.24 118.704 105.284 118.77 105.313 118.843C105.343 118.915 105.358 118.993 105.357 119.071C105.358 119.149 105.343 119.227 105.313 119.3C105.284 119.372 105.24 119.438 105.184 119.493C105.129 119.549 105.063 119.592 104.99 119.622C104.918 119.652 104.84 119.667 104.762 119.666Z",
    fill: "white",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M105.062 118.466H68.9663C68.8342 118.466 68.707 118.416 68.6108 118.326C68.5145 118.235 68.4565 118.112 68.4486 117.98L66.4864 94.4247C66.4776 94.3517 66.4844 94.2777 66.5064 94.2077C66.5285 94.1376 66.5652 94.073 66.6142 94.0182C66.6632 93.9634 66.7233 93.9196 66.7905 93.8898C66.8578 93.8601 66.9306 93.8449 67.0041 93.8455H107.029C107.103 93.8449 107.176 93.8601 107.243 93.8898C107.31 93.9196 107.37 93.9634 107.419 94.0182C107.468 94.073 107.505 94.1376 107.527 94.2077C107.549 94.2777 107.556 94.3517 107.547 94.4247L105.585 117.98C105.577 118.113 105.518 118.237 105.421 118.327C105.323 118.418 105.195 118.468 105.062 118.466Z",
    fill: "white",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4207 106.562C90.4207 107.968 88.8934 109.106 87.0141 109.106C85.1348 109.106 83.6023 107.968 83.6023 106.562C83.6023 105.155 85.1296 104.023 87.0141 104.023C88.8986 104.023 90.4207 105.16 90.4207 106.562Z",
    fill: "white",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M125.693 88.1622C126.247 87.7308 126.636 87.1231 126.796 86.4402C126.912 85.928 126.9 85.395 126.76 84.8888",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M121.562 106.603C121.562 106.603 125.005 104.535 123.881 102.171C122.758 99.808 118.958 98.2411 118.958 94.5591C118.958 91.3839 122.338 90.2101 124.544 88.9379",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M124.741 106.536C124.741 106.536 126.661 105.259 126.661 103.231C126.661 101.871 125.207 100.982 123.286 98.7944",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M122.224 97.4706C122.224 97.4706 120.967 96.4828 121.893 94.6263",
    stroke: "#222222",
    strokeWidth: 0.26804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0767 43.3012C93.6928 43.1719 95.013 42.6652 95.9035 40.6018C95.9172 40.5706 95.9246 40.537 95.9252 40.5029C95.9259 40.4688 95.9198 40.4349 95.9073 40.4032C95.8948 40.3715 95.8761 40.3425 95.8524 40.318C95.8286 40.2936 95.8002 40.274 95.7689 40.2605C95.7056 40.2342 95.6346 40.2336 95.5708 40.2587C95.507 40.2838 95.4555 40.3326 95.4272 40.395C94.6092 42.2877 93.4391 42.7065 92.9525 42.7996C93.8234 41.7469 94.3043 40.4264 94.3141 39.0608C94.3141 35.4719 90.9851 32.5656 86.8796 32.5656C82.7741 32.5656 79.4451 35.4719 79.4451 39.0608C79.4479 40.3713 79.8848 41.6441 80.6876 42.6807C79.9059 42.6393 78.5857 42.9703 76.9134 44.9198C76.8657 44.9691 76.839 45.0349 76.839 45.1034C76.839 45.172 76.8657 45.2378 76.9134 45.287C76.9615 45.3269 77.0219 45.3488 77.0843 45.3491C77.122 45.3491 77.1591 45.3408 77.1932 45.3247C77.2272 45.3086 77.2572 45.2851 77.281 45.256C79.4192 42.7686 80.8326 43.1875 81.1174 43.3012C80.6339 43.5668 80.1808 43.8841 79.7661 44.2476C77.3794 46.3937 75.9246 50.4531 76.111 53.8352C76.3205 56.0783 77.1345 58.2228 78.4666 60.0407C80.2001 58.8015 81.6375 57.1945 82.6757 55.3348C83.4494 53.9689 84.1409 52.558 84.7466 51.1099C84.7466 52.6251 84.9433 54.4557 85.7406 55.7641C86.3158 56.7975 87.1583 57.6576 88.1802 58.2543C89.2021 58.8511 90.3657 59.1627 91.5495 59.1564C91.9582 59.1623 92.3663 59.1224 92.7661 59.0375C92.8012 59.0287 92.8341 59.0127 92.8627 58.9904C92.8912 58.9681 92.9147 58.9401 92.9318 58.9082C94.9302 59.3322 96.9182 59.2961 97.2237 58.872C97.7155 58.1946 98.4144 56.0795 98.6474 53.4939C99.072 49.1086 96.3073 45.3025 93.0767 43.3012ZM86.2221 55.4486C85.2177 53.8093 85.2488 51.1357 85.3679 49.5999L85.4352 49.424C85.4829 51.0037 85.886 52.5523 86.6147 53.9551C87.3433 55.3579 88.3788 56.5789 89.6442 57.5275C90.3433 58.0101 91.1186 58.372 91.9377 58.5979C90.6693 58.6858 88.06 58.4428 86.2221 55.4486Z",
    fill: "#222222"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M86.31 47.309C86.31 47.309 85.8854 50.4428 89.8719 53.5145C93.8584 56.5863 97.6377 55.3762 97.6377 55.3762",
    stroke: "white",
    strokeWidth: 0.13402,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M86.895 46.2747C86.895 46.2747 91.0938 52.382 96.8922 50.7893",
    stroke: "white",
    strokeWidth: 0.13402,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8191 44.2424C84.157 43.9066 83.4153 43.7589 82.6748 43.8154C81.9344 43.872 81.2237 44.1306 80.6204 44.563C78.389 46.0472 77.2708 49.5533 77.2708 49.5533",
    stroke: "white",
    strokeWidth: 0.13402,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9278 45.9438C84.9278 45.9438 83.121 45.4628 82.0027 46.5798C81.4577 47.0732 80.9915 47.647 80.6204 48.2812",
    stroke: "white",
    strokeWidth: 0.13402,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorking);
export default __webpack_public_path__ + "static/media/working.9121ab14e43e0670a8a6438ff1cf16d4.svg";
export { ForwardRef as ReactComponent };